(function () {
  var script = document.currentScript;
  var sectionId = script && script.dataset.sectionId;
  var slider   = document.getElementById('acs-slider-' + sectionId);
  if (!slider) return;

  var slides   = Array.from(slider.querySelectorAll('.acs-slide'));
  var content  = slider.querySelector('.acs-slide__content');
  var pill     = slider.querySelector('.acs-swatches-pill');
  var swatches = Array.from(slider.querySelectorAll('.acs-swatch'));
  var prevBtns = Array.from(slider.querySelectorAll('.acs-arrow--prev'));
  var nextBtns = Array.from(slider.querySelectorAll('.acs-arrow--next'));
  var total    = slides.length;
  var current  = 0;
  var busy     = false;

  if (total <= 1) return;

  var SLIDE_DUR = 1.0;

  /* ── Product animation (GSAP) ─────────────────────────────── */
  function triggerAnim(slide, delay) {
    var p = slide.querySelector('.acs-slide__product[data-anim]');
    if (!p || p.dataset.anim === 'none') return;
    gsap.killTweensOf(p);
    var d = delay || 0;
    var vw = window.innerWidth || 1280;
    switch (p.dataset.anim) {
      case 'scale_in':
        // Stark von sehr klein → groß, aus Zentrum
        gsap.fromTo(p, { scale: 0.3, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.75, delay: d, ease: 'back.out(1.4)', transformOrigin: 'center center' });
        break;
      case 'scale_in_up':
        // Sanft: von 0 auf 100 skalieren, dabei leicht nach oben gleiten
        gsap.fromTo(p, { scale: 0, y: 48, opacity: 0 }, { scale: 1, y: 0, opacity: 1, duration: 0.9, delay: d, ease: 'power2.out', transformOrigin: 'center bottom' });
        break;
      case 'popup':
        // Pop-in: Scale mit Overshoot, während es nach oben slidet
        gsap.fromTo(p, { scale: 0.35, y: 80, opacity: 0 }, { scale: 1, y: 0, opacity: 1, duration: 0.6, delay: d, ease: 'back.out(2.4)', transformOrigin: 'center bottom' });
        break;
      case 'bounce_up':
        // Bounce nach oben in die Endposition
        gsap.fromTo(p, { y: 90, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9, delay: d, ease: 'bounce.out' });
        break;
      case 'slide_up_bounce':
        // Schneller und dramatischer
        gsap.fromTo(p, { y: 110, opacity: 0 }, { y: 0, opacity: 1, duration: 0.55, delay: d, ease: 'back.out(2.2)' });
        break;
      case 'slide_up_smooth':
        gsap.fromTo(p, { y: 60, opacity: 0 }, { y: 0, opacity: 1, duration: 0.55, delay: d, ease: 'power2.out' });
        break;
      case 'slide_right':
        // SlideInRight: von links komplett aus dem Viewport herein — schnell,
        // elastischer Overshoot, dann mit Bremse zurück auf Position. Racing Bike.
        gsap.fromTo(p,
          { x: -(vw * 1.15), opacity: 0 },
          { x: 0, opacity: 1, duration: 0.5, delay: d, ease: 'back.out(2.6)' }
        );
        break;
      case 'slide_left':
        // SlideInLeft: spiegelverkehrt — von rechts komplett aus dem Viewport herein.
        gsap.fromTo(p,
          { x: (vw * 1.15), opacity: 0 },
          { x: 0, opacity: 1, duration: 0.5, delay: d, ease: 'back.out(2.6)' }
        );
        break;
    }
  }

  var enablePageloadAnim = script && script.dataset.enablePageloadAnim === 'true';

  /* ── Init ──────────────────────────────────────────────────── */
  function init() {
    var sectionEl = document.getElementById('acs-' + sectionId);
    var isEditor  = script && script.dataset.designMode === 'true';

    slides.forEach(function (slide, i) {
      if (i === 0) {
        gsap.set(slide, { visibility: 'visible', zIndex: 1 });
      } else {
        gsap.set(slide, { visibility: 'hidden', zIndex: 0 });
      }
    });

    // No pageload animation: show the section unclipped + product immediately.
    // The inline guard script only sets --clip:1 when the animation runs, but
    // reset it here too so the editor and any stale value can't leave the
    // section clipped to a small rectangle.
    if (isEditor || !enablePageloadAnim) {
      if (sectionEl) sectionEl.style.setProperty('--clip', '0');
      triggerAnim(slides[0], 0);
      return;
    }

    gsap.fromTo(sectionEl,
      { '--clip': 1 },
      { '--clip': 0, duration: 1.4, ease: 'power3.inOut' }
    );
    gsap.fromTo(slider,
      { scale: 1.5, transformOrigin: 'center center' },
      { scale: 1,   duration: 1.4, ease: 'power3.inOut' }
    );
    // Product fires at 1.0s — near the end of the 1.4s reveal
    gsap.delayedCall(1.0, function () { triggerAnim(slides[0], 0); });
  }

  /* ── Slide navigation ──────────────────────────────────────── */
  function goTo(idx, dir) {
    if (busy) return;
    idx = ((idx % total) + total) % total;
    if (idx === current) return;

    busy = true;
    var fromIdx = current;
    var from    = slides[fromIdx];
    var to      = slides[idx];

    if (swatches[current]) { swatches[current].classList.remove('acs-swatch--active'); swatches[current].setAttribute('aria-pressed', 'false'); }
    if (swatches[idx])     { swatches[idx].classList.add('acs-swatch--active');    swatches[idx].setAttribute('aria-pressed', 'true'); }

    if (content && to.dataset.textColor) {
      content.style.setProperty('--acs-text', to.dataset.textColor);
      content.style.setProperty('--acs-cta-bg', to.dataset.ctaBg);
      content.style.setProperty('--acs-cta-tc', to.dataset.ctaTc);
      content.style.setProperty('--acs-cta-hover-bg', to.dataset.ctaHoverBg);
      content.style.setProperty('--acs-cta-hover-tc', to.dataset.ctaHoverTc);
    }

    if (pill && to.dataset.pillBorder) {
      pill.style.setProperty('--acs-pill-border', to.dataset.pillBorder);
      pill.style.setProperty('--acs-pill-shadow', to.dataset.pillShadow);
    }

    // will-change nur für die Dauer des Übergangs (CSS trägt es nicht mehr
    // permanent auf allen Slides).
    gsap.set(to, { visibility: 'visible', zIndex: 2, willChange: 'clip-path' });
    gsap.set(from, { zIndex: 1, willChange: 'clip-path' });

    // Product fires at 0.4s into the 1.0s clip-path transition — slide is ~40% revealed
    triggerAnim(to, 0.4);

    var tl = gsap.timeline({
      defaults: { duration: SLIDE_DUR, ease: 'power2.inOut' },
      onComplete: function () {
        from.classList.remove('acs-slide--active');
        to.classList.add('acs-slide--active');
        gsap.set(from, { visibility: 'hidden', zIndex: 0, clearProps: 'clipPath', willChange: 'auto' });
        gsap.set(to, { zIndex: 1, clearProps: 'clipPath', willChange: 'auto' });
        busy = false;
      }
    });

    if (dir > 0) {
      tl.fromTo(to,   { clipPath: 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)' }, { clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, -30% 100%)' });
      tl.fromTo(from, { clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' },    { clipPath: 'polygon(0% 0%, 0% 0%, -30% 100%, 0% 100%)' }, '<');
    } else {
      tl.fromTo(to,   { clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)' },        { clipPath: 'polygon(0% 0%, 100% 0%, 130% 100%, 0% 100%)' });
      tl.fromTo(from, { clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' },    { clipPath: 'polygon(100% 0%, 100% 0%, 100% 100%, 130% 100%)' }, '<');
    }

    current = idx;
  }

  prevBtns.forEach(function (b) { b.addEventListener('click', function () { goTo(current - 1, -1); }); });
  nextBtns.forEach(function (b) { b.addEventListener('click', function () { goTo(current + 1,  1); }); });
  swatches.forEach(function (sw, i) {
    sw.addEventListener('click', function () { goTo(i, i > current ? 1 : -1); });
  });

  // Cycling brand colors on arrow hover — reads from theme CSS custom properties.
  // Silver and yellow are light colors, so the icon switches to midnight blue on them.
  var rootStyle = getComputedStyle(document.documentElement);
  var navyIcon  = rootStyle.getPropertyValue('--color-brand-midnight-mood').trim();
  var arrowHoverColors = [
    { css: '--color-brand-sprint-pink' },
    { css: '--color-brand-coastal-ride' },
    { css: '--color-brand-violett-velo' },
    { css: '--color-brand-midnight-mood' },
    { css: '--color-brand-sunshine-yellow', light: true },
    { css: '--color-brand-urban-silver', light: true }
  ].map(function (c) {
    return { color: rootStyle.getPropertyValue(c.css).trim(), light: !!c.light };
  }).filter(function (c) { return c.color; });

  var arrowColorIdx = 0;
  prevBtns.concat(nextBtns).forEach(function (btn) {
    btn.addEventListener('mouseenter', function () {
      if (!arrowHoverColors.length) return;

      var activeBg = (slides[current] && slides[current].dataset.bgColor || '').trim().toLowerCase();
      var entry;
      for (var tries = 0; tries < arrowHoverColors.length; tries++) {
        entry = arrowHoverColors[arrowColorIdx % arrowHoverColors.length];
        arrowColorIdx++;
        if (entry.color.trim().toLowerCase() !== activeBg) break;
      }

      btn.style.setProperty('--acs-arrow-bg-hover', entry.color);
      if (entry.light && navyIcon) {
        btn.style.setProperty('--acs-arrow-icon-hover', navyIcon);
      } else {
        btn.style.removeProperty('--acs-arrow-icon-hover');
      }
    });
  });

  var dragStartX = 0;
  var dragStartY = 0;
  var isDragging = false;
  var wasDrag    = false;
  var DRAG_THRESHOLD = 50;
  var AXIS_LOCK = 10;

  var activePointerId = null;

  slider.addEventListener('pointerdown', function (e) {
    if (e.button !== 0) return;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    isDragging = false;
    wasDrag    = false;
    activePointerId = e.pointerId;
  }, { passive: true });

  slider.addEventListener('pointermove', function (e) {
    if (!e.buttons || e.pointerId !== activePointerId) return;
    var dx = e.clientX - dragStartX;
    var dy = e.clientY - dragStartY;
    if (!isDragging && Math.abs(dx) > AXIS_LOCK && Math.abs(dx) > Math.abs(dy)) {
      isDragging = true;
      slider.style.cursor = 'grabbing';
      // Capture only once we're sure it's a horizontal drag — not on button clicks
      slider.setPointerCapture(e.pointerId);
    }
  });

  slider.addEventListener('pointerup', function (e) {
    slider.style.cursor = '';
    if (!isDragging) return;
    wasDrag    = true;
    isDragging = false;
    var dx = e.clientX - dragStartX;
    if (Math.abs(dx) > DRAG_THRESHOLD) {
      var d = dx < 0 ? 1 : -1;
      goTo(current + d, d);
    }
  });

  // Two-finger trackpad horizontal scroll
  var wheelAcc     = 0;
  var WHEEL_THRESH = 60;
  var wheelTimer   = null;

  slider.addEventListener('wheel', function (e) {
    if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) return; // vertical scroll — let browser handle
    e.preventDefault();
    wheelAcc += e.deltaX;
    clearTimeout(wheelTimer);
    wheelTimer = setTimeout(function () { wheelAcc = 0; }, 300);
    if (Math.abs(wheelAcc) >= WHEEL_THRESH) {
      var d = wheelAcc > 0 ? 1 : -1;
      wheelAcc = 0;
      goTo(current + d, d);
    }
  }, { passive: false });

  // CTA button: smoothly scroll to an on-page anchor instead of letting the
  // browser jump straight there. section.settings.cta_link can point at
  // another section's anchor_id span (see the liquid template) — plain
  // <a href="#id"> links have no smooth-scroll behavior anywhere in this
  // theme, so without this the button just snapped to position.
  var ctaLinks = Array.from(slider.querySelectorAll('.acs-cta'));
  ctaLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;
      var target = document.getElementById(href.slice(1));
      if (!target) return; // not an on-page anchor — let the browser handle it normally

      e.preventDefault();
      var headerEl = document.querySelector('.header-section');
      var headerH  = headerEl ? headerEl.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerH;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  // Suppress the click that fires after a horizontal drag
  slider.addEventListener('click', function (e) {
    if (wasDrag) {
      wasDrag = false;
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // animations.min.js loads after content_for_layout (bottom of <body>),
  // so we must defer the gsap check until DOMContentLoaded — at which point
  // all synchronous scripts have run and gsap is guaranteed to exist.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof gsap !== 'undefined') init();
    });
  } else {
    // Theme editor or late-loaded section: scripts already present
    if (typeof gsap !== 'undefined') init();
  }
})();
